const HTML5Backend = require('react-dnd-html5-backend');
const ReactDnd = require('react-dnd');

const DndContext = ReactDnd.createDndContext(HTML5Backend.default);

// react-dnd does not allow more than one HTML5Backend to
// be rendered on the same page, because they would compete
// with each other to handle the same browser events. This
// creates conflicts if e.g. a component uses react-dnd and
// then the user opens a filter modal (the advanced filters
// also use react-dnd). We solve this by having all components
// share the same backend.
exports.DndContext = DndContext;
